// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form-check {\n    font-size: 1.5rem;\n    color:red\n}\n\n.form-check-input{\n    margin-top: 0.6rem;\n \n}", "",{"version":3,"sources":["webpack://src/css/addpropiedadform.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;;AAEtB","sourcesContent":[".form-check {\n    font-size: 1.5rem;\n    color:red\n}\n\n.form-check-input{\n    margin-top: 0.6rem;\n \n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
